export default __webpack_public_path__ + "static/media/heart.9316f239.svg";